import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  cached: {}
}

export const getters = {}

export const mutations = {
  SCHEDULE(state, request) {
    state.cached = request
  }
}

export const actions = {

  init({ state, dispatch }) { },

  fetchScheduling(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/scheduling/${query}`).then((response) => {
      const request = response.data
      context.commit('SCHEDULE', request)
      return request
    })
  },

  fetchSchedulingCompleteAll(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/scheduling/complete/${query}`).then((response) => {
      const request = response.data
      return request
    })
  },

  fetchSchedulingCompleteAllMe(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/scheduling/complete/me/${query}`).then((response) => {
      const request = response.data
      return request
    })
  },

  fetchSchedulingCompleteAllAdmin(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/scheduling/complete/admin/${query}`).then((response) => {
      const request = response.data
      return request
    })
  },

  fetchSchedulingCompleteCounting(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/scheduling/complete/counting/${query}`).then((response) => {
      const request = response.data
      return request
    })
  },

  fetchSchedulingProject(context, id, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/scheduling/project/${id}/${query}`).then((response) => {
      const request = response.data
      return request
    })
  },

  fetchSchedulingIGuest(context, id, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/scheduling/i/guest/${query}`).then((response) => {
      const request = response.data
      return request
    })
  },

  fetchSchedulingCompleteAllAdvisers(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/scheduling/complete/advisers/${query}`).then((response) => {
      const request = response.data
      return request
    })
  },

  fetchSelfScheduling(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/scheduling/me/${query}`).then((response) => {
      const request = response.data
      // context.commit('SCHEDULE', request)
      return request
    })
  },

  fetchAdminScheduling(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/scheduling/admin/${query}`).then((response) => {
      const request = response.data
      // context.commit('SCHEDULE', request)
      return request
    })
  },

  fetchAdvisersScheduling(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/scheduling/me/advisers/${query}`).then((response) => {
      const request = response.data
      // context.commit('SCHEDULE', request)
      return request
    })
  },

  fetchScheduleOptions(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/scheduling/options/${query}`).then((response) => {
      return response.data
    })
  },

  fetchScheduleDetail(context, id) {
    return axios.get(`${serverUrl}/api/scheduling/${id}/`).then((response) => {
      return response.data
    })
  },

  fetchScheduleReport(context, payload) {
    return axios.get(`${serverUrl}/api/scheduling/${payload.schedule_id}/report/`, payload.type).then((response) => {
      return response
    })
  },


  fetchSchedulingResourceRequests(context, payload) {
    // query = query || ''
    return axios.get(`${serverUrl}/api/scheduling/${payload.id}/${payload.resources}/${payload.query}`).then((response) => {
      const request = response.data
      // context.commit('SCHEDULE', request)
      return request
    })
  },

  fetchSchedulingResourceDetail(context, payload) {
    // query = query || ''
    return axios.get(`${serverUrl}/api/scheduling/${payload.id}/${payload.resources}/${payload.resource_id}/`).then((response) => {
      const request = response.data
      // context.commit('SCHEDULE', request)
      return request
    })
  },

  createUpdateSchedulingResourceRequests(context, payload) {
    let promise = null
    if (payload.form.url) {
      promise = axios.put(payload.form.url, payload.form)
    } else {
      promise = axios.post(`${serverUrl}/api/scheduling/${payload.id}/${payload.resource}/`, payload.form)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  createUpdateSchedule(context, payload) {
    let promise = null
    if (payload.id) {
      promise = axios.patch(`${serverUrl}/api/scheduling/${payload.id}/`, payload)
    } else {
      promise = axios.post(`${serverUrl}/api/scheduling/`, payload)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  deleteSchedule(context, id) {
    let promise = null
    promise = axios.delete(`${serverUrl}/api/scheduling/${id}`)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  //Attendance
  fetchAttendance(context, payload) {
    let query = payload.query || ''
    return axios.get(`${serverUrl}/api/scheduling/${payload.schedule_id}/participants/${query}`).then((response) => {
      const request = response.data
      return request
    })
  },

  createAttendance(context, payload) {
    return axios.post(`${serverUrl}/api/scheduling/${payload.schedule_id}/participants/`, payload.data).then((response) => {
      const request = response.data
      return request
    })
  },

  // Survey
  fetchScheduleSurvey(context, schedule_id) {
    return axios.get(`${serverUrl}/api/scheduling/${schedule_id}/surveys/me`).then((response) => {
      const request = response.data
      return request
    })
  },

  createUpdateScheduleSurvey(context, payload) {
    let promise = null
    if (payload.data.id) {
      promise = axios.put(`${serverUrl}/api/scheduling/${payload.schedule_id}/surveys/${payload.data.id}/`, payload.data)
    } else {
      promise = axios.post(`${serverUrl}/api/scheduling/${payload.schedule_id}/surveys/`, payload.data)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  // Files
  fetchScheduleFiles(context, payload) {
    return axios.get(`${serverUrl}/api/scheduling/${payload.schedule_id}/files/`).then((response) => {
      return response.data
    })
  },

  deleteScheduleFile(context, payload) {
    return axios.delete(`${serverUrl}/api/scheduling/${payload.schedule_id}/files/${payload.file_id}`).then((response) => {
      return response.data
    })
  },

}
